/**
 * Auth Actions
 */

import { LOGIN_USER, LOGIN_USER_SUCCESS, LOGIN_USER_FAILURE, LOGOUT_USER, ME, LOGIN_LOADING, SET_CONFIG } from 'Actions/types';
import AppConfig from 'Constants/AppConfig';

/**
 * Redux Action To Sign In User
 */

export const signInLoading = loading => dispatch => {
  dispatch({ type: LOGIN_LOADING, payload: loading });
};

export const signInFromRecruitment = data => dispatch => {
  if (!data || !data.token) {
    dispatch({ type: LOGIN_USER_FAILURE });
    return;
  }
  localStorage.setItem('token', data.token);
  dispatch({
    type: LOGIN_USER_SUCCESS,
    payload: { token: data.token },
  });
};

export const signInUser = (data, navigate, type, field) => async dispatch => {
  if (!data || !data.token) {
    await dispatch({ type: LOGIN_USER_FAILURE });
    return;
  }
  await localStorage.setItem('token', data.token);
  await dispatch({
    type: LOGIN_USER_SUCCESS,
    payload: { token: localStorage.getItem('token') },
  });
  if (type === 'calendar') {
    navigate('/admin/calendar', { replace: true, state: field });
  } else if (type === 'transaction') {
    navigate('/admin/transaction/transactions/list', { replace: true, state: field });
  } else {
    navigate('/admin/dashboard', { replace: true });
  }
};

/**
 * Redux Action To Signout User
 */
export const logoutUser = () => dispatch => {
  dispatch({ type: LOGOUT_USER });
  localStorage.removeItem('token');
  localStorage.removeItem('pageHistory');
};

export const updateMe = data => dispatch => {
  if (!data) {
    dispatch({ type: LOGOUT_USER });
    localStorage.removeItem('token');
    return;
  }

  let staffList = [];
  let fieldList = [];
  if (data.partner && data.partner.materialBuyer) {
    const { staffs, fields } = data.partner.materialBuyer;
    staffList = (staffs && Array.isArray(staffs) && staffList.concat(staffs)) || [];
    fieldList = (fields && Array.isArray(fields) && fieldList.concat(fields)) || [];
    staffList = staffList.map(staff => {
      const keys = ['_id', 'active', 'name', 'phone', 'id'];
      return Object.keys(staff)
        .filter(key => keys.includes(key))
        .reduce((o, k) => {
          return {
            ...o,
            [k]: staff[k],
          };
        }, {});
    });
    fieldList = fieldList.map(field => {
      const keys = ['_id', 'active', 'name'];
      return Object.keys(field)
        .filter(key => keys.includes(key))
        .reduce((o, k) => {
          return {
            ...o,
            [k]: field[k],
          };
        }, {});
    });
  }
  dispatch({ type: ME, payload: data });
  dispatch({ type: SET_CONFIG, payload: { staffList, fieldList } });
};
